import { Message } from "@/store/chats/types";
import { getIsMessageCallType } from "./getIsMessageCallType";
import { getIsMessageFriendRequestType } from "./getIsMessageFriendRequestType";

export const getIsAutomaticMessageType = (message: Message) =>
  getIsMessageCallType(message) || getIsMessageFriendRequestType(message);
